'use strict'

import 'isomorphic-unfetch'
import i18n from 'i18next'
import it from './../../static/locales/it/common.json'
import en from './../../static/locales/en/common.json'

/**
 * Initialize a i18next instance.
 * @function startI18n
 * @param {object} files - Translation files.
 * @param {string} lang - Active language.
 */
export const startI18n = (files, lang) => i18n.init({
  lng: lang, // active language http://i18next.com/translate/
  fallbackLng: process.env.DEFAULT_LANG,
  resources: files,
  ns: ['common'],
  defaultNS: 'common',
  debug: false
})

/**
 * get translation file(s).
 * @function getTranslation
 * @param {string} lang - Language to fetch.
 * @return {object} translation files.
 */
export async function getTranslation(lang = process.env.DEFAULT_LANG) {

  switch (lang) {
  case 'it':
    return Promise.resolve({ it: { common: it } })
    
  case 'en':
  default:
    return Promise.resolve({ en: { common: en } })
  }

}



// WEBPACK FOOTER //
// src/helpers/i18n.js